import React from 'react';
import { Box, Image, Link } from '@chakra-ui/react';

export default function BrandLogoCard({ brand }) {
  const content = (
    <Image src={brand.logo} alt={brand.name} maxH="48px" maxW="100%"
      objectFit="contain" loading="lazy" decoding="async"
      filter="grayscale(1)" opacity={0.72}
      transition="filter 200ms ease, opacity 200ms ease, transform 200ms ease" />
  );

  const boxProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    h: '96px',
    px: 4,
    bg: 'surface.default',
    borderRadius: 'md',
    border: '1px solid',
    borderColor: 'border.default',
    transition: 'all 200ms ease',
    _hover: { borderColor: 'accent.default', transform: 'translateY(-2px)' },
    _focusVisible: { borderColor: 'accent.default', boxShadow: 'outline' },
    sx: {
      '&:hover img, &:focus-visible img, &:focus-within img': {
        filter: 'grayscale(0)', opacity: 1, transform: 'scale(1.02)',
      },
    },
  };

  // Sin URL confirmada no se genera enlace: el brief prohíbe href="#".
  if (!brand.url) {
    return <Box role="group" aria-label={brand.name} tabIndex={0} {...boxProps}>{content}</Box>;
  }

  return (
    <Link href={brand.url} target="_blank" rel="noopener noreferrer"
      aria-label={`Sitio web de ${brand.name}`} {...boxProps}>
      {content}
    </Link>
  );
}
